module.exports = __webpack_public_path__ + "img/rules3.9e02cdb6.png";